// api/income.js
import { apiGet ,apiPost} from './http'

// GET /app/income/home
export function fetchAppIncomeHome(config = {}) {
  return apiGet(
    '/app/income/home',
    {},
    {
      silent: true,
      ...config
    }
  )
}

// GET /app/income/asset/page
export function fetchAppAssetPage(params = {}, config = {}) {
  return apiGet(
    '/app/income/asset/page',
    {
      current: params.current || 1,
      size: params.size || 10,
      tabType: params.tabType || 'USDT'
    },
    {
      silent: true,
      ...config
    }
  )
}

// GET /app/income/asset/detail/{id}
export function fetchAppAssetDetail(id, config = {}) {
  return apiGet(
    `/app/income/asset/detail/${id}`,
    {},
    {
      silent: true,
      ...config
    }
  )
}

// GET /app/income/withdraw/detail/{withdrawNo}
export function fetchAppWithdrawDetail(withdrawNo, config = {}) {
  return apiGet(
    `/app/income/withdraw/detail/${withdrawNo}`,
    {},
    {
      silent: true,
      ...config
    }
  )
}

/**
 * =========================
 * 提现申请（APP）
 * =========================
 */

/**
 * POST /admin/app/account/withdraw/apply
 *
 * DTO:
 *  - coinType: "USDT"
 *  - amount: BigDecimal
 *  - reason?: string
 */
export function applyWithdraw(params = {}, config = {}) {
    const {
      coinType,
      amount,
      reason = "",
    } = params || {};
  
    // 基础前端校验（避免无意义请求）
    if (amount === undefined || amount === null || Number(amount) <= 0) {
      return Promise.reject(new Error("请输入正确的提现金额"));
    }
  
    return apiPost(
      "/app/account/withdraw/apply",
      {
        coinType,
        amount,
        reason,
      },
      {
        // 后端返回的是 R.ok(msg)，这里默认给成功提示
        successMsg: "Successful",
        ...config,
      }
    );
  }